import { render } from "./BankTransfer.vue?vue&type=template&id=65fc528a&scoped=true"
import script from "./BankTransfer.vue?vue&type=script&lang=js"
export * from "./BankTransfer.vue?vue&type=script&lang=js"

import "./BankTransfer.vue?vue&type=style&index=0&id=65fc528a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fc528a"]])

export default __exports__